import { loadView } from '@/router'

export default [
  {
    path: 'campaigns',
    name: 'customerservice-campaigns',
    component: loadView('Application/CustomerService/Campaigns'),
    showInAlfred: true,
    alfredTitle: 'Customer Service - Campaigns'
  }
]
